import React, { useContext } from 'react';
import { EditApkContext, IEditApkContext } from 'modules/FirmwareAndApp/Apk/EditApk/editApkState/editApkContext';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import style from './DownloadBtn.module.scss';

const DownloadBtn: React.FC = () => {
	const { filePath } = useContext<IEditApkContext>(EditApkContext);

	return (
		<div className={style.container}>
			<BlobDownloader filePath={filePath} fileExtension="apk" fileName="tablet_app" label="downloadApkLabel" />
		</div>
	);
};

export default DownloadBtn;
